import RubberTable from './table';
export default RubberTable;
